import io from 'socket.io-client';

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

const socket = io(SOCKET_URL, {
  autoConnect: false,
  withCredentials: true,
  transports: ['websocket', 'polling'],
});

export const connectRealtime = () => {
  socket.auth = {
    token: localStorage.getItem('token'),
  };

  if (!socket.connected) {
    socket.connect();
  }
};

export const disconnectRealtime = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};

export const subscribeToRealtimeEvent = (event, callback) => {
  connectRealtime();
  socket.on(event, callback);

  return () => {
    socket.off(event, callback);
  };
};

export const subscribeToNotifications = (callback) => {
  return subscribeToRealtimeEvent('newNotification', callback);
};

export const unsubscribeFromNotifications = (callback) => {
  if (callback) {
    socket.off('newNotification', callback);
    return;
  }

  socket.off('newNotification');
};

export default socket;
